export default "__VITE_ASSET__Tr3r3ymE__"